import {propiedadesDlCl} from '../../productos/propiedades/state';

export const tarea = () => {
    return {
        id_empresa: null,
        id_ubicacion: null,
        id_fabricante: null,
        id_producto: null,
        id_componente: null,
        id_categoria: null,
        proceso: null,
        id_cargo_trabajador: null,
        tarea: null,
        ari_task_id: null,
        ari_hygienic_measurement_id: null,
        wor_position_id: null,
        descripcion: null,
        id_ges: null,
        numero_trabajadores_expuestos: null,
        turnos: null,
        id_um_temperatura_proceso: null,
        temperatura_proceso: null,
        id_cantidad_dia: null,
        cantidad_dia: null,
        frecuencia: null,
        id_frecuencia_1: null,
        id_frecuencia_2: null,
        id_via_ingreso: null,
        id_superficie_expuesta_dermico: null,
        id_clase_pulverulencia: null,
        id_clase_procedimiento: null,
        total_horas_semanales_laborales: null,
        total_horas_diarias_laborales: null,
        id_unidad_medida_tlv: null,
        tlv: 1,
        presion_vapor_corregida: null,
        id_proteccion_colectiva: 1,
        suspension_liquida: 0,
        nota_ifv: 0,
        azeotropo: 0,
        id_um_temperatura_azeotropo: null,
        temperatura_azeotropo: null,
        operacion_pulverizacion: 0,
        cambio_temperatura: 0,
        plaguicida: 0,
        estado_producto: null,
        location_ids: []
    };
};

export const filtros = () => {
    return {
        fechas: [],
        tarea: '',
        id_empresa: null,
        id_ubicacion: [],
        id_fabricante: null,
        id_producto: null,
        id_usuario_creacion: null,
        page: 1,
        per_page: 10,
        ids: [],
        level: null
    };
};


export const chartsDataDefault = () => {
    return {
        tasks: [],
        levels: [],
        quantity: 0,
        level_info: null,
        status_info: null,
        charges_info: null,
        components_info: null,
        areas_info: null,
        route_of_entry_info: null,
        exposed_workers: null,
        color: null
    }
}

export const defaultPropiedades = () => {
    return {
        id_producto: null,
        peso_molecular: null,
        punto_ebullicion_rango: 0,
        id_um_punto_ebullicion: null,
        punto_ebullicion: null,
        punto_ebullicion_hasta: null,
        unidad_punto_ebullicion: {
            lista: ''
        }
    };
};

export default {
    tarea: tarea(),
    tareas: {
        data: []
    },
    propiedades: defaultPropiedades(),
    modal_propiedades: {ver: false},
    modal: {ver: false},
    accion: 'crear',
    filtros: filtros(),
    lista_temporal: [],
    empresas: JSON.parse(localStorage.getItem('empresas')) || [],
    empresas_filtro: [],
    ubicaciones: [],
    ubicaciones_filtro: [],
    fabricantes: [],
    fabricantes_filtro: [],
    productos: [],
    componentes: [],
    usuarios: [],
    productos_filtro: [],
    cargos: [],
    ges: [],
    categorias: [],
    categorias_sga: [],
    cargando_datos_select: false,
    opciones_superficies_expuestas: [],
    unidades_de_temperatura: [],
    capacidades: [],
    unidades_de_presion: [],
    unidades_de_viscosidad: [],
    clases_de_procedimiento: [],
    clases_de_pulverulencia: [],
    unidades_de_medida_tlv: [],
    opciones_frecuencia_1: [],
    opciones_frecuencia_2: [],
    vias_ingreso: [],
    opciones_si_no: [
        {text: 'SI', value: 1},
        {text: 'NO', value: 0}
    ],
    opciones_proteccion_colectiva: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13
    ],
    resultado: {
        tlv: null,
        caracterizacion_riesgo: {
            prioridad: 0,
            caracterizacion: null
        },
        clase_cantidad: null,
        clase_exposicion_potencial: null,
        clase_frecuencia: null,
        clase_riesgo_potencial: null,
        factor_conversion_tlv: null,
        id_clase_peligro: null,
        puntuacion_procedimiento_colectivo: null,
        puntuacion_proteccion_colectiva: null,
        puntuacion_pulverulencia: null,
        puntuacion_riesgo_inhalacion: null,
        puntuacion_riesgo_potencial: null
    },
    modal_attachments: {view: false},
    product_selected: null,
    charts_data: chartsDataDefault(),
    levels: [
        {
            label: 'Nivel 1',
            value: '1',
        },
        {
            label: 'Nivel 2',
            value: '2',
        },
        {
            label: 'Nivel 3',
            value: '3',
        },
        {
            label: 'Todos',
            value: '4',
        },
    ],
    tasks: [],
    positions: [],
    hygienic_measurements: [],
    workers: [],
    controls: []
};
